<template>
  <div
    ref="$el"
    class="partnership-quote"
  >
    <UiComponentImage
      v-if="backgroundImageIsReady"
      :key="`background-${backgroundImageWidth}x${backgroundImageHeight}`"
      alt="Background"
      class="background"
      :expected-size="backgroundImageWidth >= backgroundImageHeight ? backgroundImageWidth : backgroundImageHeight"
      :extra-params="{
        fit: 'crop',
        h: backgroundImageHeight,
        w: backgroundImageWidth,
      }"
      :height="backgroundImageHeight"
      source="https://livestorm.imgix.net/1127/1700569880-pattern.jpg"
      :width="backgroundImageWidth"
    />
    <UiComponentImage
      v-if="props.data.logo"
      :alt="props.data.logo.alt"
      class="logo"
      :expected-size="20"
      :orientation="props.data.logo.width >= props.data.logo.height ? 'portrait' : 'landscape'"
      :height="props.data.logo.height"
      :source="props.data.logo.url"
      :width="props.data.logo.width"
    />
    <UiComponentParagraph class="quote">
      {{ props.data.quote }}
    </UiComponentParagraph>
    <div class="author">
      <UiComponentImage
        v-if="props.data.profilePicture"
        :alt="props.data.profilePicture.alt"
        class="profile"
        :expected-size="48"
        :extra-params="{
          fit: 'crop',
          h: 48,
          w: 48,
        }"
        :height="props.data.profilePicture.height"
        :source="props.data.profilePicture.url"
        :width="props.data.profilePicture.width"
      />
      <div class="information">
        <UiComponentParagraph class="name">
          {{ props.data.author }}
        </UiComponentParagraph>
        <UiComponentParagraph class="job">
          {{ props.data.job }}
        </UiComponentParagraph>
      </div>
    </div>
  </div>
</template>

<script setup>
// Props
const props = defineProps({
  data: {
    required: true,
    type: Object,
  },
})

// Refs
const $el = ref(null)
const backgroundImageHeight = ref(0)
const backgroundImageIsReady = ref(false)
const backgroundImageWidth = ref(0)
const resizeObserver = ref(null)

// Methods
function onObserve() {
  const { offsetHeight, offsetWidth } = $el.value
  backgroundImageHeight.value = offsetHeight
  backgroundImageWidth.value = offsetWidth
  backgroundImageIsReady.value = true
}

// Lifecycle Hooks
onBeforeUnmount(() => {
  resizeObserver.value.disconnect()
})

onMounted(() => {
  resizeObserver.value = new ResizeObserver(onObserve)
  resizeObserver.value.observe($el.value)
})
</script>

<style lang="postcss" scoped>
.partnership-quote {
  @apply relative flex flex-col w-full p-14 bg-winter-green-900 rounded-4xl overflow-hidden;

  .background {
    @apply absolute inset-0 rounded-none z-0;
  }

  .logo {
    @apply rounded-none z-10;
  }

  .quote {
    @apply mt-14 text-white z-10;
  }

  .author {
    @apply flex items-center mt-6 z-10;

    .profile {
      @apply flex-shrink-0 rounded-full;
    }

    .information {
      @apply flex flex-col ml-4;

      p {
        @apply font-medium text-white;

        & + p {
          @apply font-normal text-sm leading-6;
        }
      }
    }
  }
}
</style>
